import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { DQRulesContext } from '@zillow/hollywood-common';
import { createMicroFrontend } from '@zillow/frontier';
import { Spacer } from '@zillow/constellation';
import { useHasBeenVisible } from '@zillow/use-visibility';
import MstHomeDetailsGoogleAds, { AD_TYPE } from './MstHomeDetailsGoogleAds';

const VISIBILITY_MARGIN = '0px 0px 50% 0px';

function MstHomeDetailsNeighborhoodAds({ targets, variant, versOn }) {
    // Get whether we should hide ads based on DQ rules
    const { dataQualityRules } = useContext(DQRulesContext);
    const dqRuleAdsRestricted = dataQualityRules?.getRule('isAdsRestricted');

    // Defer ads until in view in order to reduce unfilled ad requests
    const target = useRef();
    const hasBeenVisible = useHasBeenVisible(target, false, { rootMargin: VISIBILITY_MARGIN });
    return (
        // this ad is never shown when ads are restricted
        !dqRuleAdsRestricted && (
            <Spacer marginBottom="md" ref={target}>
                {hasBeenVisible && (
                    <MstHomeDetailsGoogleAds
                        className="home-details-neighborhood-ads"
                        targets={targets}
                        deferred={false}
                        variant={variant}
                        versOn={versOn}
                        targetDiv="hdp_nhood_slot_box_1"
                        adType={AD_TYPE.ACCIPITER_AD}
                        deferTargetFrame={false}
                        eventName="Neighborhood"
                    />
                )}
            </Spacer>
        )
    );
}

MstHomeDetailsNeighborhoodAds.propTypes = {
    targets: PropTypes.object,
    variant: PropTypes.string,
    versOn: PropTypes.string,
};

const MstHomeDetailsNeighborhoodMicroFrontend = createMicroFrontend({
    Component: MstHomeDetailsNeighborhoodAds,
    onMicroFrontendLoad() {
        console.log('success load');
    },
    onMicroFrontendLoadError() {
        console.error('error loading');
    },
    fetchData: async () => {},
    getGraphQLFragments: () => {},
});

export default MstHomeDetailsNeighborhoodMicroFrontend;
